import React from "react";
import { Theme, makeStyles } from "@material-ui/core/styles";
import Accordion from "@material-ui/core/Accordion";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { size } from "@mvp/design-system";
import { useBool } from "../../../hooks/useBool";
import { Summary } from "./Summary";
import { Details } from "./Details";

const useStyles = makeStyles<Theme, {hideRightMargin: boolean | undefined}>((theme) => ({ 
  accordion: {
    borderRadius: '.375rem',
    boxShadow: `0rem .25rem .5rem rgba(0, 0, 0, 0.160784)`,
    border: `0.063rem solid #DDDAD7`,
    borderTop: "none",
    padding: `${size.xxs(theme)} ${size.l(theme)} 1.5rem`,
    '&.MuiAccordion-root:last-child': {
      marginBottom: '3.25rem',
      [theme.breakpoints.between('md','lg')]: {
        marginBottom: size.l(theme),
        marginRight: (props: any) => props.hideRightMargin ? '' : '2.5rem'
      }
    },
    [theme.breakpoints.down("sm")]: {
      height: "8rem",
      position: "fixed",
      left: 0,
      right: 0,
      bottom: 100,
      padding: `0 ${size.m(theme)}`,
      backgroundColor: "white",
      zIndex: 1000,
    },
    '@media print': {
      position: 'static !important',
      left: 'auto !important',
      right: 'auto !important',
      bottom: 'auto !important',
      overflow: 'visible',
      height: 'auto',
      border: '0.063rem solid #DDDAD7',
    },
  },
  icon: {
    color: theme.palette.primary.main,
    fontSize: '3rem',
    padding: 0
  },
}));

const PlanOverview: React.FC<{hideRightMargin?: boolean}> = ({hideRightMargin}) => {
  const classes = useStyles({hideRightMargin});

	const {bool: isExpanded, flipBool} = useBool(false);

  return (
    <Accordion
      expanded={isExpanded}
      onChange={flipBool}
      className={classes.accordion}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon className={classes.icon} />}
      >
        <Summary />
      </AccordionSummary>
      <AccordionDetails>
        <Details />
      </AccordionDetails>
    </Accordion>
  );
};

export default PlanOverview;